import product1_1 from './product1_1.png'
import product1_2 from './product1_2.png'
import product1_3 from './product1_3.png'
import product1_4 from './product1_4.png'
import product2_1 from './product2_1.png'
import product2_2 from './product2_2.png'
import product2_3 from './product2_3.png'
import product3_1 from './product3_1.png'
import product3_2 from './product3_2.png'
import product3_3 from './product3_3.png'
import product3_4 from './product3_4.png'
import product4_1 from './product4_1.png'
import product4_2 from './product4_2.png'
import product4_3 from './product4_3.png'
import product4_4 from './product4_4.png'
import product5_1 from './product5_1.png'
import product5_2 from './product5_2.png'
import product5_3 from './product5_3.png'
import product5_4 from './product5_4.png'
import product6_1 from './product6_1.png'
import product6_2 from './product6_2.png'
import product6_3 from './product6_3.png'
import product7_1 from './product7_1.png'
import product7_2 from './product7_2.png'
import product7_3 from './product7_3.png'
import product7_4 from './product7_4.png'
import product8_1 from './product8_1.png'
import product8_2 from './product8_2.png'
import product8_3 from './product8_3.png'
import product8_4 from './product8_4.png'
import product9_1 from './product9_1.png'
import product9_2 from './product9_2.png'
import product9_3 from './product9_3.png'
import product9_4 from './product9_4.png'
import product10_1 from './product10_1.png'
import product10_2 from './product10_2.png'
import product10_3 from './product10_3.png'
import product10_4 from './product10_4.png'

const product_images = {
    product1: {
        product1_1,
        product1_2,
        product1_3,
        product1_4,
    },
    product2: {
        product2_1,
        product2_2,
        product2_3,
    },
    product3: {
        product3_1,
        product3_2,
        product3_3,
        product3_4,
    },
    product4: {
        product4_1,
        product4_2,
        product4_3,
        product4_4,
    },
    product5: {
        product5_1,
        product5_2,
        product5_3,
        product5_4,
    },
    product6: {
        product6_1,
        product6_2,
        product6_3,
    },
    product7: {
        product7_1,
        product7_2,
        product7_3,
        product7_4,
    },
    product8: {
        product8_1,
        product8_2,
        product8_3,
        product8_4,
    },
    product9: {
        product9_1,
        product9_2,
        product9_3,
        product9_4,
    },
    product10: {
        product10_1,
        product10_2,
        product10_3,
        product10_4,
    },
}

export default product_images ;